/**
 *  @description 국내 주문서 > types/shared.ts - v1, v2 공통 타입 (enum, QS 타입, 상수 등)
 */

export enum ItemType {
  Property = 'property',
  Leisure = 'leisure',
  Train = 'train',
  Bus = 'bus',
}

export type PropertyQS = {
  type: ItemType.Property
  propertyId: number
  checkInDate: string
  checkOutDate: string
  checkInAt: string
  checkOutAt: string

  // roomTypeId & useType 혹은 ratePlanId & ratePlanVersion 존재해야함
  roomTypeId?: number // 신규생성 숙소의 경우 없을 수 있음.
  useType: 'R' | 'S' | 'D'
  ratePlanId?: number
  ratePlanVersion?: number

  surchargeIds?: number[]
  adults: number
  childrenAges?: number[]
}

export type LeisureQS = {
  type: ItemType.Leisure
  id: number
  productVersion?: number
  options: {
    id: number
    quantity: number
    date?: string
    time?: string
  }[]
}

export type TrainItemQS = {
  trainNo: string
  goodsNo: string
  departureStationCode: string
  runningDate: string
  arrivalStationCode: string
  carriageClassCode: string
  seats: string[]
}

export type TrainQS = {
  type: ItemType.Train
  adults: number
  child: number
  single: TrainItemQS
  returns?: TrainItemQS
}

export type MetaQS = {
  trackCode?: string | null
  trackcode?: string | null
  cartId?: string
  cartOptionIds?: string[]
  isCartSelectAll?: string
  srpKeyword?: string
  cgntId?: string // query string 아님
  orderGroupId?: string // 추가 구매건 대응을 위한 원 주문 번호.
}

export type BusQS = {
  type: ItemType.Bus
  going: BusItemQS
  returns: BusItemQS
}

export type BusItemQS = {
  allocationArrivalTerminalNo: string
  allocationDepartureTerminalNo: string
  allocationDepartureTime: string
  arrivalTerminalNo: string
  busGrade: BusGradeQS
  departureDate: string
  departureTerminalNo: string
  departureTime: string
  transportationCompanyCode: string
  seats: BusItemSeatQS[]
  totalSeats: number
}

export type BusItemSeatQS = {
  seatNo: number
  ticketType: string
}

export type BusGradeQS = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8'

export type ProductQS = PropertyQS | LeisureQS | TrainQS | BusQS
export type ItemQS = ProductQS | MetaQS

export type PageParams = Record<number, ItemQS>
